import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const TableViewIcon = ({
  width = "26",
  height = "26",
  color = "#1C3C6C",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.5625 4.0625C23.5625 3.63152 23.3913 3.2182 23.0865 2.91345C22.7818 2.6087 22.3685 2.4375 21.9375 2.4375H4.0625C3.63152 2.4375 3.2182 2.6087 2.91345 2.91345C2.6087 3.2182 2.4375 3.63152 2.4375 4.0625V21.9375C2.4375 22.3685 2.6087 22.7818 2.91345 23.0865C3.2182 23.3913 3.63152 23.5625 4.0625 23.5625H21.9375C22.3685 23.5625 22.7818 23.3913 23.0865 23.0865C23.3913 22.7818 23.5625 22.3685 23.5625 21.9375V4.0625ZM21.9375 4.0625V7.3125H4.0625V4.0625H21.9375ZM21.9375 21.9375H4.0625V18.6875H21.9375V21.9375ZM21.9375 17.0625H4.0625V13.8125H21.9375V17.0625ZM21.9375 12.1875H4.0625V8.9375H21.9375V12.1875Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
